import { Chip, makeStyles, Tooltip } from '@material-ui/core';
import { PatientProgress } from 'hydra-data-types';
import { FunctionComponent } from 'react';
import { colors } from '../../../theme/colors';

type ComplianceProps = {
  missedDays: PatientProgress['missedDays'];
  programNotStarted: boolean;
};

export const Compliance: FunctionComponent<ComplianceProps> = (props) => {
  const { missedDays, programNotStarted } = props;

  const MAX_MISSED_DAYS_ALLOWED = 3;
  const isCompliant = missedDays !== undefined && missedDays <= MAX_MISSED_DAYS_ALLOWED;

  const classes = useStyles({ compliant: isCompliant });

  // The status is shown only for core program users
  if (!programNotStarted && missedDays !== undefined) {
    return (
      <div data-testid="compliance-status">
        {isCompliant ? (
          <Chip label="On track" className={classes.compliance} size="small" variant="outlined" />
        ) : (
          <Tooltip title="Missed last 3 days" arrow className={classes.tooltip}>
            <Chip
              label="Non-compliant"
              className={classes.compliance}
              size="small"
              variant="outlined"
            />
          </Tooltip>
        )}
      </div>
    );
  } else {
    return <></>;
  }
};

type useStyleProps = { compliant: boolean };
const useStyles = makeStyles({
  compliance: {
    borderColor: ({ compliant }: useStyleProps) => (compliant ? colors.green : colors.red),
    color: ({ compliant }: useStyleProps) => (compliant ? colors.green : colors.red),
    borderRadius: 100,
    marginLeft: 20,
    fontSize: 12,
    padding: '10px',
  },
  tooltip: {
    '&:hover': {
      cursor: 'pointer',
    },
  },
});
